import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import FavoriteSuggestion from '../../types/FavoriteSuggestion';
import FavoriteSuggestionType from '../../types/FavoriteSuggestionType';
import { isFolderInFavorites } from 'owa-favorites';
import { MoveToFolderType, getFoldersForMoveTo } from 'owa-mail-moveto-control';

export default function getFavoriteFolderSuggestions(findText: string): FavoriteSuggestion[] {
    const maxFolderSuggestions = getMaxFavoriteSuggestionCounts().folder;

    // Find top matching folders not already in favorites
    const folders = getFoldersForMoveTo(
        'primary',
        findText,
        maxFolderSuggestions,
        folderId => !isFolderInFavorites(folderId)
    ).folders; /* customFilter */

    const items: FavoriteSuggestion[] = folders.map((folder: MoveToFolderType) => {
        const folderDisplayName = folder.displayName;

        return {
            id: folder.folderId,
            data: folderDisplayName,
            type: FavoriteSuggestionType.Folder,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });

    return items;
}
